<ng-container *ngTemplateOutlet="showNewAnalystRatings() ? newView : oldView"/>

<ng-template #newView>
  <!-- New analyst rating -->
  @if (showAnalystRatings() && asRatingsConsensus(); as ratings) {
    <div class="td-wb-rating__container">
      <div class="td-wb-rating__item-container">
        <span class="td-wb-rating-item td-wb-rating-item--sell">
          <span class="td-wb-rating-item__pointer"
                [class.td-wb-rating-item__pointer--active]="isRating(AnalystRatings.SELL)">
          </span>
          <span class="td-wb-rating-item__bar td-wb-rating-item__bar--sell"></span>
          <span class="td-wb-rating-item__label">
            <span translate="tdWb.analystRating.SELL_LBL"></span>&nbsp;
            <span [innerText]="ratings.ratingSell"></span>
          </span>
        </span>
        <span class="td-wb-rating-item td-wb-rating-item--hold">
          <span class="td-wb-rating-item__pointer"
                [class.td-wb-rating-item__pointer--active]="isRating(AnalystRatings.HOLD)">
          </span>
          <span class="td-wb-rating-item__bar td-wb-rating-item__bar--hold"></span>
          <span class="td-wb-rating-item__label">
            <span translate="tdWb.analystRating.HOLD_LBL"></span>&nbsp;
            <span [innerText]="ratings.ratingHold"></span>
          </span>
        </span>
        <span class="td-wb-rating-item td-wb-rating-item--buy">
          <span class="td-wb-rating-item__pointer"
                [class.td-wb-rating-item__pointer--active]="isRating(AnalystRatings.BUY)">
          </span>
          <span class="td-wb-rating-item__bar td-wb-rating-item__bar--buy"></span>
          <span class="td-wb-rating-item__label">
            <span translate="tdWb.analystRating.BUY_LBL"></span>&nbsp;
            <span [innerText]="ratings.ratingBuy"></span>
          </span>
        </span>
      </div>
      <div class="td-wb-rating__description">
        <a class="td-wb-link"
           [attr.href]="( linkId | tdWbHref) + getLinkParams()">
          @if (ratings.numberOfAnalysts !== undefined) {
            <span [innerText]="ratings.numberOfAnalysts"></span>
          }
          <span translate="tdWb.analystRating.ANALYST_CONSENSUS_NEW"></span>
          <strong [translate]="'tdWb.analystRating.consensusValues.' + overallConsensus"></strong>
          <td-wb-icon iconId="caret-right--small"
                      [inline]="true"/>
        </a>
      </div>
    </div>
  }
</ng-template>

<ng-template #oldView>
  <!-- LEGACY ANALYST RATING -->
  @if (showAnalystRatings()) {
    <div class="td-wb-ratings__content-legacy">
      <ul aria-hidden="true"
          class="td-wb-ratings__ul-legacy">
        <li class="td-wb-ratings__item-legacy td-wb-ratings__item--red-legacy"
            [class.td-wb-ratings__item--active-legacy]="overallConsensus === AnalystRatings.SELL">
          <span translate="tdWb.analystRating.SELL_LBL"></span>
        </li>
        <li class="td-wb-ratings__item-legacy td-wb-ratings__item--red-line-legacy"
            [class.td-wb-ratings__item--active-legacy]="overallConsensus === AnalystRatings.UNDERPERFORM">
          <span translate="tdWb.analystRating.UNDER_PERFORM_LBL"></span>
        </li>
        <li class="td-wb-ratings__item-legacy td-wb-ratings__item--yellow-legacy"
            [class.td-wb-ratings__item--active-legacy]="overallConsensus === AnalystRatings.HOLD">
          <span translate="tdWb.analystRating.HOLD_LBL"></span>
        </li>
        <li class="td-wb-ratings__item-legacy td-wb-ratings__item--green-line-legacy"
            [class.td-wb-ratings__item--active-legacy]="overallConsensus === AnalystRatings.BUY">
          <span translate="tdWb.analystRating.BUY_LBL"></span>
        </li>
        <li class="td-wb-ratings__item-legacy td-wb-ratings__item--green-legacy"
            [class.td-wb-ratings__item--active-legacy]="overallConsensus === AnalystRatings.STRONG_BUY">
          <span translate="tdWb.analystRating.STRONG_BUY_LBL"></span>
        </li>
      </ul>
    </div>
  }
  @if (showAnalystRatings()) {
    <div class="td-wb-ratings__cons-legacy">
      <span translate="tdWb.analystRating.ANALYST_CONSENSUS"></span>:
      <strong [translate]="'tdWb.analystRating.consensusValues.' + overallConsensus"></strong>
    </div>
  }
</ng-template>

